export const pixTypes = [
	{ name: "CPF", value: "NaturalRegistrationNumber" },
	{ name: "CNPJ", value: "LegalRegistrationNumber" },
	{ name: "E-mail", value: "Email" },
	{ name: "Celular", value: "Phone" },
	{ name: "Chave Aleatória", value: "Automatic" },
	{ name: "Agência e Conta", value: "AgencyAndAccount" },
];